module.exports = __webpack_public_path__ + "img/settings.27456501.svg";